import PropTypes from "prop-types";
import Button from "components/ui/Button/Button";
import { useDialog } from "context/DialogContext";
import { useGroupAccess } from "features/groups/hooks/useGroupAccess";
import Loader from "components/ui/Loader/Loader";
import GroupMemberRequestAccessDialog from "features/groups/components/GroupMemberRequestAccessDialog";
import Alert from "components/ui/Alert/Alert";
import { useState } from "react";

const GroupMemberAccessButton = ({ groupId, groupMemberId, isPrivate, onCompleted }) => {
  const { showDialog } = useDialog();
  const [ error, setError ] = useState();
  const { working, requestAccess } = useGroupAccess();

  const addGroupMember = async () => {
    setError(null);

    const response = await requestAccess(groupId, groupMemberId);

    if (response?.status === 409) {
      setError('U bent al lid van deze groep, ververs de pagina om de groep te bekijken.');
      return;
    }

    if (!response?.ok) {
      setError('Onbekende fout, probeer het later opnieuw.');
      return;
    }

    const result = await response.json();
    onCompleted(result);
  }

  if (working) {
    return <Loader loaderVariant={ `small` } />;
  }

  return (
    <>
      { error && <Alert message={ error } /> }
      {
        isPrivate ?
          <Button variant={ `secondary` }
                  onClick={ () => showDialog(<GroupMemberRequestAccessDialog groupId={ groupId }
                                                                             groupMemberId={ groupMemberId }
                                                                             onCompleted={ onCompleted } />) }>Toegang aanvragen</Button>
        :
          <Button variant={ `secondary` }
                  onClick={ () => addGroupMember() }>Groepslid worden</Button>
      }
    </>
  )
}

GroupMemberAccessButton.propTypes = {
  groupId: PropTypes.number.isRequired,
  groupMemberId: PropTypes.number,
  isPrivate: PropTypes.bool.isRequired,
  onCompleted: PropTypes.func.isRequired
}

export default GroupMemberAccessButton;
